var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"war-room-commission-earn-banner-point"},[_c('CommissionPointIcon',{class:{ 'war-room-commission-earn-banner-point__icon': _vm.count }}),_vm._v(" "),(_vm.count)?[_vm._v("\n      "+_vm._s(_vm.pointsCount)+"\n    ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }